// About 3 — "About the Program" two-column block: heading, paragraph, highlight
// callout, key-highlight stats (min 1 / max 6), lead-drawer CTA, side image.

export const ABOUT_3_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    icon: "",
    icon_alt: "",
    heading: "Duration",
    subtext: "",
    show_divider: true,
    divider_color: "#E0E0E0",
    priority: 1,
    status: true,
  },

  // Bullet points (metadata_1) — default row for a new bullet.
  DEFAULT_ROW_1: {
    id: "1",
    text: "",
    icon: "",
    icon_alt: "",
    font_weight: "500",
    font_color: "#101112",
    priority: 1,
    status: true,
  },

  METADATA_TITLES: {
    metadata: "Key Highlights (min 1, max 6)",
    metadata_1: "Bullet Points (min 1, max 4)",
  },

  // Min 1 / Max 6 key highlights (PRD). Enforced in the admin: "Add New Row"
  // caps at the max and Save is blocked outside the range.
  METADATA_LIMITS: {
    metadata: { min: 1, max: 6 },
    metadata_1: { min: 1, max: 4 },
  },

  ABOUT_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    // Heading (mandatory, 2 lines max)
    {
      fieldName: "title",
      label: "Heading",
      value: "About the Online MBA in Product Management",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter heading (max 2 lines)",
      required: true,
      defaultValue: "About the Online MBA in Product Management",
    },
    {
      fieldName: "title_text_color",
      label: "Heading Text Color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter heading text color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
    },
    // Paragraph (optional)
    {
      fieldName: "description",
      label: "Paragraph (optional)",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter paragraph text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_text_color",
      label: "Paragraph Text Color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter paragraph text color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
    },
    // Highlight callout (optional, 3 lines max)
    {
      fieldName: "sub_text",
      label: "Highlight Text (optional)",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter highlight text (max 3 lines)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "sub_text_color",
      label: "Highlight Text Color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter highlight text color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "highlight_border_color",
      label: "Highlight Border / Accent Color",
      value: "#9F1C34",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter highlight border color (e.g., #9F1C34)",
      required: false,
      defaultValue: "#9F1C34",
    },
    // Side image (optional — upload a pre-rounded asset; no CSS radius applied)
    {
      fieldName: "show_image",
      label: "Show Side Image",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide the side image",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "desktop_image",
      label: "Side Image — Desktop (optional, pre-rounded)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop side image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Side Image — Mobile (optional; falls back to desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile side image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Side Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for side image",
      required: false,
      defaultValue: "",
    },
    // CTA (opens the lead form drawer)
    {
      fieldName: "cta_label",
      label: "CTA Label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA label",
      required: true,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_icon",
      label: "CTA Icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_icon_alt",
      label: "CTA Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for CTA icon",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_bg_color",
      label: "CTA Background Color",
      value: "#9F1C34",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA background color (e.g., #9F1C34)",
      required: false,
      defaultValue: "#9F1C34",
    },
    {
      // Shadow color is auto-derived from the CTA background color.
      fieldName: "cta_enable_shadow",
      label: "CTA Shadow",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable CTA shadow",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "show_key_highlights",
      label: "Show Key Highlights",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide the key highlights block",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "key_highlight_heading_color",
      label: "Key Highlight Heading Color",
      value: "#9F1C34",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter key highlight heading color (e.g., #9F1C34)",
      required: false,
      defaultValue: "#9F1C34",
    },
    {
      fieldName: "key_highlight_subtext_color",
      label: "Key Highlight Subtext Color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter key highlight subtext color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "key_highlight_divider_color",
      label: "Key Highlight Divider Color",
      value: "rgba(0,0,0,0.1)",
      valueType: "string",
      // RGBA (not COLOR) — the divider default is translucent, and ColorField's
      // text input only accepts hex.
      filedType: "RGBA",
      placeholder: "Enter key highlight divider color (e.g., rgba(0,0,0,0.1))",
      required: false,
      defaultValue: "rgba(0,0,0,0.1)",
      helperText:
        "Default for all rows — a per-row Divider Color in the table overrides it.",
    },
    {
      fieldName: "status",
      label: "About Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable About",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon (optional)",
      fieldName: "icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon",
    },
    {
      header: "Icon Alt",
      fieldName: "icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter icon alt text",
    },
    {
      header: "Heading",
      fieldName: "heading",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g., Duration",
    },
    {
      header: "Subtext (max 2 lines)",
      fieldName: "subtext",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter subtext",
    },
    {
      header: "Divider",
      fieldName: "show_divider",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide divider",
      defaultValue: true,
    },
    {
      header: "Divider Color",
      fieldName: "divider_color",
      value: "#E0E0E0",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter divider color (e.g., #E0E0E0)",
      defaultValue: "#E0E0E0",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable this item",
      defaultValue: true,
    },
  ],

  // Bullet Points (metadata_1) — min 1 / max 4. Each bullet has its own text,
  // optional icon, font weight and text colour. No line-clamp on the text.
  METADATA_FIELDS_1: [
    {
      header: "Bullet Text",
      fieldName: "text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g., Two-year program that builds a solid base",
      required: true,
      defaultValue: "",
    },
    {
      header: "Icon (optional)",
      fieldName: "icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload bullet icon",
      defaultValue: "",
    },
    {
      header: "Icon Alt",
      fieldName: "icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter icon alt text",
      defaultValue: "",
    },
    {
      header: "Font Weight",
      fieldName: "font_weight",
      value: "500",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select font weight",
      defaultValue: "500",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Regular (400)", value: "400" },
        { label: "Medium (500)", value: "500" },
        { label: "Semibold (600)", value: "600" },
        { label: "Bold (700)", value: "700" },
      ],
    },
    {
      header: "Text Color",
      fieldName: "font_color",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color (e.g., #101112)",
      defaultValue: "#101112",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable this bullet",
      defaultValue: true,
    },
  ],
};
